import React from "react";
import { Box, Button, Modal, Slider, Stack, Typography } from "@mui/material";
import { useVectorModal } from "../../hooks/useVectorModal";
import { modalStyle } from "../modal-style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faSave } from "@fortawesome/free-solid-svg-icons";

const VectorModal = () => {
    const {
        vector,
        setVector,
        vectorModalOpen,
        setVectorModalOpen,
        handleSave
    } = useVectorModal();

    const handlePopularityChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, popularity: newValue});
        }
    }

    const handleEnergyChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, energy: newValue});
        }
    }

    const handleLoudnessChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, loudness: newValue});
        }
    }

    const handleTempoChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, tempo: newValue});
        }
    }

    const handleValenceChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, valence: newValue});
        }
    }

    const handleAcousticnessChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, acousticness: newValue});
        }
    }

    const handleTimbreChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, timbre: newValue});
        }
    }

    const handleAggressivenessChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, aggressiveness: newValue});
        }
    }

    const handleCurrentnessChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, currentness: newValue});
        }
    }

    const handlePsychedeliaChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, psychedelia: newValue});
        }
    }

    const handleFlowChange = (event: Event, newValue: number | number[]) => {
        if (typeof newValue === 'number' && vector) {
            setVector({...vector, flow: newValue});
        }
    }

    return (
        <Modal open={vectorModalOpen}>
            <Box sx={modalStyle}>
                <Stack spacing={1} direction="column">
                    <Box>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Edit Characteristics
                        </Typography>
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Uncommon</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Popularity</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Common</Typography></Box>
                        </Stack>
                        <Slider value={vector?.popularity} onChange={handlePopularityChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Low</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Energy</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>High</Typography></Box>
                        </Stack>
                        <Slider value={vector?.energy} onChange={handleEnergyChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Soft</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Loudness</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Loud</Typography></Box>
                        </Stack>
                        <Slider value={vector?.loudness} onChange={handleLoudnessChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Slow</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Tempo</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Fast</Typography></Box>
                        </Stack>
                        <Slider value={vector?.tempo} onChange={handleTempoChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Negative</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Valence</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Positive</Typography></Box>
                        </Stack>
                        <Slider value={vector?.valence} onChange={handleValenceChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Electronic</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Acousticness</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Acoustic</Typography></Box>
                        </Stack>
                        <Slider value={vector?.acousticness} onChange={handleAcousticnessChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Dark</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Timbre</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Bright</Typography></Box>
                        </Stack>
                        <Slider value={vector?.timbre} onChange={handleTimbreChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Passive</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Aggressiveness</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Aggressive</Typography></Box>
                        </Stack>
                        <Slider value={vector?.aggressiveness} onChange={handleAggressivenessChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Old</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Currentness</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Current</Typography></Box>
                        </Stack>
                        <Slider value={vector?.currentness} onChange={handleCurrentnessChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Ordinary</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Psychedelia</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Psychedelic</Typography></Box>
                        </Stack>
                        <Slider value={vector?.psychedelia} onChange={handlePsychedeliaChange} min={-1} max={1} step={0.1} />
                    </Box>
                    <Box>
                        <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="left" sx={{ color: 'text.secondary' }}>Melodic</Typography></Box>
                            <Box sx={{ width: '50%' }}><Typography variant="body1" align="center">Flow</Typography></Box>
                            <Box sx={{ width: '25%' }}><Typography variant="body2" align="right" sx={{ color: 'text.secondary' }}>Rapping</Typography></Box>
                        </Stack>
                        <Slider value={vector?.flow} onChange={handleFlowChange} min={-1} max={1} step={0.1} />
                    </Box>
{/* 
    // Uncommon - Common
    public float Popularity { get; set; } = 0;

    // Low - High
    public float Energy { get; set; } = 0;

    // Quiet - Loud
    public float Loudness { get; set; } = 0;

    // Slow - Fast
    public float Tempo { get; set; } = 0;

    // Negative - Positive
    public float Valence { get; set; } = 0;

    // Acoustic - Electronic
    public float Acousticness { get; set; } = 0;    

    // Passive - Aggressive
    public float Aggressiveness { get; set; } = 0;

    // Old - Current
    public float Currentness { get; set; } = 0;

    // Dark - Bright */}
                    
                    <Box display="flex" justifyContent="space-between">
                        <Button variant="contained" size="small" onClick={() => setVectorModalOpen(false)} color="error">
                            <FontAwesomeIcon fontSize="large" color="primary" icon={faCancel} className="icon" />
                            Cancel
                        </Button>
                        <Button variant="contained" size="small" onClick={handleSave} color="primary">
                            <FontAwesomeIcon fontSize="large" color="primary" icon={faSave} className="icon" />
                            Save
                        </Button>
                    </Box>
                </Stack>
            </Box>
        </Modal>
    )
}

export default VectorModal;